import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const mutation = gql`
  mutation RewardEmployees(
    $sourceId: ID!
    $destinationUserIds: [ID!]!
    $amount: Int!
    $message: String!
    $budget: BudgetCategoryRequest
    $occasionId: ID
    $title: String
  ) {
    rewardEmployees(
      sourceId: $sourceId
      destinationUserIds: $destinationUserIds
      amount: $amount
      message: $message
      budget: $budget
      occasionId: $occasionId
      title: $title
    ) {
      uuid
      transferIds
      message
      metadata {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`

export const rewardEmployeesKey = getQueryNames(mutation)[0]

export default mutation
